import { Injectable, signal } from '@angular/core';
import { ToastMessageInterface } from "../interfaces/toast-message.interface";

@Injectable({
  providedIn: 'root',
})
export class ToastMessageService {

  messageSignal = signal<ToastMessageInterface>({
    primaryMessage: '',
    secondMessage: '',
    type: 'success',
  })
  openToastMessageSignal = signal<boolean>(false)

  constructor() { }

  openToastDialog(message: ToastMessageInterface): void {
    this.messageSignal.set({
      primaryMessage: message.primaryMessage,
      secondMessage: message.secondMessage,
      type: message.type ?? 'success',
    });
    this.openToastMessageSignal.set(true);
  }
}
